<template>
  <div class="lampGroup-page" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="pageInfo" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="6">
            <el-form-item :label="$t('device.strategy')">
              <el-select
                clearable
                filterable
                :placeholder="$t('device.select_strategy')"
                v-model="pageInfo.stg_id"
                style="width: 100%"
              >
                <el-option
                  v-for="t in strategyList"
                  :key="t.id"
                  :label="t.title"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column prop="name" :label="$t('lampGroup.group_name')"></el-table-column>
        <el-table-column prop="is_double" :label="$t('lampGroup.group_type')" align="center" width="220">
          <template slot-scope="scope">
            {{ doubleType[scope.row.is_double] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lampGroup.manage')">
          <template slot-scope="scope">
            <span @click="openDeviceData(scope.row)" class="my-icon-button">{{$t('lampGroup.manage')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="desc" :label="$t('control.desc')"> </el-table-column>

        <el-table-column prop="edit" :label="$t('lampGroup.control')">
          <template slot-scope="scope">
            <div class="edit-button">
              <el-button type="primary" class="small-btn" @click="groupControlVibile(scope.row, 1)" round>{{$t('lampGroup.open')}}</el-button>
              <el-button type="info" class="small-btn"  @click="groupControlVibile(scope.row, 0)" round>{{$t('lampGroup.close')}}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="120px"
        :rules="editOneRule"
      >
        <div class="user-info">
          <el-form-item :label="$t('lampGroup.group_name')" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>

          <el-form-item :label="$t('control.order')" prop="sort">
            <el-input v-model="editOne.sort"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lampGroup.group_type')">
            <el-select
              :placeholder="$t('lampGroup.group_type')"
              v-model="editOne.is_double"
              style="width: 100%"
            >
              <el-option
                v-for="(t,index) in doubleType"
                :key="index"
                :label="t"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('control.desc')" prop="desc">
            <el-input v-model="editOne.desc"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
    <!--管理路灯-->
    <el-dialog
      :title="'['+deviceData.name+']'+$t('lampGroup.manage')"
      :visible.sync="deviceData.dialogVisible"
      v-if="deviceData.dialogVisible"
    >
      <device-list
        :groupId="deviceData.id"
        ref="deviceData"
        @closeMethod="closeDeviceData"
      ></device-list>
    </el-dialog>

    <!-- 组亮度控制 -->
    <el-dialog class="dialog600 groupContorl" :title="$t('lampGroup.set_light_text')+'['+setBox.name+']'" :visible.sync="setBox.dialogVisible">
      <div class="box_body p_b20">
        <el-slider
          v-model="setBox.light"
          :min="1"
          :max="100"
          show-input
        ></el-slider>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setBox.dialogVisible = false">{{$t('control.cancel')}}</el-button>
        <el-button type="primary" @click="(setBox.dialogVisible = false), lampGroupContorl(1)"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>

  </div>
</template>

<script>
import lampsGroupApi from "@/api/device/lampGroup";
import strategyApi from "@/api/device/strategy";
import deviceList from "@/components/device/lampGroup/deviceList.vue";
export default {
  components: {
    deviceList
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        stg_id: '',
        page: 1,
        pageSize: 20
      },
      cnt_all: 0,
      doubleType: this.$t('lampGroup.doubleType'),
      strategyList: [],
      editOneRule: {
        name: [{ required: true, message: this.$t('lampGroup.form_group_name'), trigger: "blur" }],
      }, 
      editType: -1,
      editOne: {},
      sendVisible: false,
      sendData: {
        group: null,
        group_name: ''
      },
      deviceData:{
        id: null,
        name: '',
        dialogVisible: false
      },
      setBox: {
        id: null,
        name: '',
        light: 0,
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
    this.getStrategyList()
  },
  methods: {
    getTableData(pageIndex) {
      this.loading = true;
      this.pageInfo.page = pageIndex;
      lampsGroupApi.lampGroupList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    getStrategyList() {
      strategyApi.strategyList({
        page: 1,
        pageSize: 500
      }).then((res) => {
        const resData = res.data.data;
        this.strategyList = resData.list;
      });
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          sort: '',
          is_double: 0,
          name: '',
          desc: ''
          
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          sort: index.sort,
          is_double: index.is_double,
          name: index.name,
          desc: index.desc
          
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      lampsGroupApi.lampGroupEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    createItem() {
      lampsGroupApi.lampGroupAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          lampsGroupApi.lampGroupDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    openDeviceData(value) {
      let newParams = { 
        id: value.id,
        name: value.name,
        dialogVisible: true
      }
      this.deviceData = newParams
    },
    closeDeviceData() {
      this.deviceData = {
        id: null,
        name: '',
        dialogVisible: false
      }
    },
    groupControlVibile(index, type) {
      this.setBox = {
        id: index.id,
        name: index.name,
        light: type?index.light:0,
        dialogVisible: type? true: false
      }
      if(!type){
        this.lampGroupContorl(0)
      }
    },
    lampGroupContorl(type) {
      lampsGroupApi.groupControl(this.setBox.id,{
        light: type?this.setBox.light:0
      }).then(res => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.command_success'))
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    }
  }
};
</script>
<style lang='less'>
.lampGroup-page {
  width: 100%;

  .dialog600.groupContorl{
    .el-dialog__footer{
      padding:0 30px 30px;
    }
  }
}
</style>